import '../scss/content.scss';
import '../scss/responsive.scss';

$(document).ready(function() {
});